import { RouteConfig } from "vue-router";

import { HomeRoute } from "./Home";
import { LoginRoute } from "./Login";
import { FaqRoute } from "./Faq";
import { InfoRoute } from "./Info";
import { ContactRoute } from "./Contact";
import { MaterialsRoute } from "./Materials";
import { PrivacyPoliciesRoute } from "./PrivacyPolicies";

export const ApplicationRoute: Array<RouteConfig> = [
  ...HomeRoute,
  ...LoginRoute,
  ...FaqRoute,
  ...InfoRoute,
  ...ContactRoute,
  ...MaterialsRoute,
  ...PrivacyPoliciesRoute
];
